import ErrorPage from './ErrorPage';
export type { ErrorPageProps } from './ErrorPage.types';

export default ErrorPage;
